var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.disabled ? _c('div', {
    staticClass: "upload-document-file-wrapper"
  }, [_c('div', {
    staticClass: "file-upload-header"
  }, [_c('b-img', {
    staticClass: "upload-file-icon",
    attrs: {
      "id": "upload-file-icon",
      "src": _vm.getUploadFileIconPath,
      "alt": "Upload File"
    }
  }), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "raft-b4 font-size-100",
    attrs: {
      "for": "document-file-upload"
    }
  }, [_vm._v(_vm._s(_vm.label))])])], 1), _vm._v(" "), _c('b-form-file', {
    ref: _vm.fileRefId,
    attrs: {
      "value": _vm.document,
      "label": _vm.label,
      "id": _vm.fieldName,
      "name": _vm.fieldName,
      "multiple": _vm.allowMultiple,
      "accept": _vm.EntityFormHelper.getAllowedFileMimeTypes(_vm.fieldConfig).join(', '),
      "file-name-formatter": _vm.fileNameFormat,
      "placeholder": ''
    },
    on: {
      "input": _vm.filesAdded
    },
    model: {
      value: _vm.selectedFile,
      callback: function ($$v) {
        _vm.selectedFile = $$v;
      },
      expression: "selectedFile"
    }
  }, [_c('template', {
    slot: "file-name"
  })], 2), _vm._v(" "), _vm._l(_vm.fileList, function (attFile, ind) {
    return _c('RaftFileUploadRow', {
      key: ind,
      attrs: {
        "attached-file": attFile,
        "disable-removal": _vm.disableRemovals
      },
      on: {
        "fileRemove": _vm.removeFileFromList
      }
    });
  }), _vm._v(" "), !_vm.suppressReplaceWarning ? _c('p', [_vm._v("\n    If a new file is uploaded, the existing file will be replaced when you\n    submit this form.\n  ")]) : _vm._e()], 2) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }